import { type IntlShape } from 'react-intl'

import { type OfferSellerShippingsDeliveryTimeV1 } from '@redteclab/api/clients/bully'

export const shippingAccessorGetFormattedShippingLeadTime = ({
  deliveryTime,
  fallbackLabel,
  intl,
}: {
  deliveryTime?: OfferSellerShippingsDeliveryTimeV1
  fallbackLabel: string
  intl: IntlShape
}): string => {
  const earliestDays = deliveryTime?.earliestDays
  const latestDays = deliveryTime?.latestDays
  const hasEarliestDays = typeof earliestDays === 'number'
  const hasLatestDays = typeof latestDays === 'number'

  if (!hasEarliestDays && !hasLatestDays) {
    return fallbackLabel
  }

  if (!hasEarliestDays || !hasLatestDays || earliestDays === latestDays) {
    const oneDayDelivery = earliestDays ?? latestDays ?? 0

    return intl.formatMessage(
      { id: 'buyBox.delivery.daysCount' },
      { count: oneDayDelivery },
    )
  }

  return intl.formatMessage(
    { id: 'buyBox.delivery.daysCount' },
    { count: `${earliestDays}-${latestDays}` },
  )
}
